<template>
  <!-- eslint-disable vue/no-v-html -->
  <highlight-html
    :queries="column.meta.highlight().split(' ')"
    :html="columnContent"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script>
import HighlightHtml from '@/components/ui/HighlightHtml.vue'

export default {
  name: 'MiaDatatableLinkColumn',

  components: {
    HighlightHtml
  },

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  computed: {
    columnContent() {
      if (this.column.representedAs) {
        return this.column.representedAs(this.row)
      }

      return this.row[this.column.field]
    }
  },

  created() {
    this.ensureMetadata()
  },

  methods: {
    ensureMetadata() {
      if (this.column.meta === undefined || Object.keys(this.column.meta).length === 0) {
        console.error('[mia-datatable-highlight-column]: Please provide a "meta" property in your column definition with the following signature: { highlight: () => string }.')
      }
    }
  }
}
</script>
